<template>
  <h1>404</h1>
</template>